import React from "react";
import { Row, Col, ListGroup } from "react-bootstrap";
import Headings from "../../../constants/headings";
import Constants from "../../../constants/constants";
import {
  GetProductStateClass,
  GetProductStateText,
  DateToPersianNumber,
  ToPersianNumber
} from "../../../functions/index";
function CurrentService(props) {
  return (
    <>
      <h2>{Headings.CurrentService}</h2>
      <Row>
        <Col>
          <ListGroup>
            <ListGroup.Item>
            <b>
                {Constants.CurrentService[3]}:&nbsp;
                <small>
                  {props.PersianActivationDate
                    ? DateToPersianNumber(props.PersianActivationDate)
                    : ""}
                </small>
              </b>
              <b>
                {Constants.CurrentService[0]}:&nbsp;
                <small>
                  {props.Title && props.Title}
                </small>
              </b>
              <b>
                {Constants.CurrentService[1]}:&nbsp;
                <small className={GetProductStateClass(props.Status)}>
                  {GetProductStateText(props.Status)}
                </small>
              </b>
             
            </ListGroup.Item>
            <ListGroup.Item>
              
              <b>
                {Constants.CurrentService[4]}:&nbsp;
                <small>
                  {props.PersianActivationDate
                    ? DateToPersianNumber(props.PersianExpirationDate)
                    : ""}
                </small>
              </b>
              <b>
                {Constants.CurrentService[2]}:&nbsp;
                <small>
                  {ToPersianNumber(props.DurationDays)}
                </small>
              </b>
              <b className={props.OperatorNameVisibility}>
                {Constants.CurrentService[5]}:&nbsp;
                <small>
                  {props.OperatorName}
                </small>
              </b>
            </ListGroup.Item>
          </ListGroup>
        </Col>
      </Row>
    </>
  );
}
export default CurrentService;
